import http from '@/utils/services/http'

export default {
  registerPopup (popup) {
    return http.post('/api/popup/new', JSON.stringify(popup))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getPopupsList () {
    return http.get('/api/popup/')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deletePopup (id) {
    return http.delete('/api/popup/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  uploadFile (file, id) {
    return http.post('/api/popup/' + id + '/upload', file, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(result => Promise.resolve(result))
      .catch(error => Promise.reject(error))
  },
  getPopup (id) {
    return http.get('/api/popup/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updatePopup (id, popup) {
    return http.patch('/api/popup/' + id + '/update', popup)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updateFoto (file, id) {
    return http.post('/api/popup/' + id + '/updateFoto', file, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(result => Promise.resolve(result))
      .catch(error => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/domain/popup/services/popup.js